import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { Szme042aResponse, SZME042AService, Szme042aRequest } from 'sg-api';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

@Injectable({
  providedIn: 'root'
})
export class UsedSzme042aService {
  /** 指定された売掛金番号における延滞利息情報取得のSubject */
  private OverdueInterestResult$: Subject<Szme042aResponse> = new Subject<Szme042aResponse>();

  /** 指定された売掛金番号における延滞利息情報のobservable提供
   * @readonly
   * @memberof UsedSzme042aService
   */
  get contractorValueChanges(): Observable<Szme042aResponse> {
    return this.OverdueInterestResult$.asObservable();
  }

  /**コンストラクタ
   * @param {SZME042AService} sZME042AService
   * @param {ApiCommonService} apiCommonService
  */
  constructor(private sZME042AService: SZME042AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 指定の売掛金番号における延滞利息情報取得API呼出し
   * @param {*} value
   * @memberof UsedSzme042aService
   * */
  searchOverdueInterest(value: any): Observable<Szme042aResponse> {
    // 検索条件を保存
    return this.sZME042AService.c17RSZME042APost(this.apiCommonService.setRequestCommon(value),'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this.OverdueInterestResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SZME042A');
          return throwError(err.message);
        })
      );
  }
}
